import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const isSxArray = (
	value: unknown,
): value is ReadonlyArray<
	| boolean
	| SystemStyleObject<Theme>
	| ((theme: Theme) => SystemStyleObject<Theme>)
> => Array.isArray(value);
